import GallonType from "../beverageType/GallonType"

const beverageFilterTypes = (filter) => {
  const types = {
    gallonType: GallonType,
  }
  return types[filter]
}

export default beverageFilterTypes
